import { render, staticRenderFns } from "./PersonalDetailsEdit.vue?vue&type=template&id=05928e3c"
import script from "./PersonalDetailsEdit.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports